<template>
    <div class="px-2 md:px-4 border-b-4">
        <div class="max-w-screen-xl mx-auto">
            <h1 class="text-4xl font-bold text-mimer-turquoise">Sök ledigt</h1>
            <div class="pt-6 flex text-sm md:text-baseflex-row overflow-x-scroll overflow-y-visible">
                <router-link tabindex="1" class="p-4 font-bold unstyled-link no-underline" to="/lediga-lagenheter"
                    >Lägenheter</router-link
                >
                <!-- CSD-4738: Temporarily hide route from menu, it may be needed again. -->
                <!-- <router-link class="p-4 font-bold unstyled-link no-underline" to="/nyproduktion"
                    >Nyproduktion</router-link
                > -->
                <router-link
                    tabindex="1"
                    class="p-4 font-bold unstyled-link no-underline whitespace-nowrap"
                    to="/co-living"
                    >Co-living</router-link
                >
                <router-link
                    tabindex="1"
                    class="p-4 font-bold unstyled-link no-underline"
                    to="/lediga-korttidslagenheter"
                    >Korttidskontrakt</router-link
                >
                <router-link
                    tabindex="1"
                    class="p-4 font-bold unstyled-link no-underline"
                    to="/lediga-parkeringsplatser"
                    >Bilplatser</router-link
                >
                <router-link tabindex="1" class="p-4 font-bold unstyled-link no-underline" to="/lediga-forrad"
                    >Förråd</router-link
                >
                <a tabindex="1" class="p-4 font-bold unstyled-link no-underline" href="https://lokaler.mimer.nu"
                    >Lokaler</a
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeadingView',
};
</script>

<style>
.router-link-active {
    color: #00a4b3;
    background-color: rgb(229, 231, 235);
}
</style>
